import Vue from 'vue';
import axios from 'axios';
import VueCookies from 'vue-cookies';
// WebSocket封装方法
export default ({
    global() {
        // 全局变量定义
        Vue.prototype.$http = axios;
        Vue.prototype.$cookies = VueCookies;
    },
});
//# sourceMappingURL=global.js.map